import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  changeWorksheet,
  changeSection,
  updateWorksheetInput
} from 'state/actions/action-creators';

import { InputFormMap } from 'html-worksheets/@types';
import worksheetsMap from 'html-worksheets/worksheetsMap';
import { Box } from '@mui/material';

const SheetEditor = props => {
  const [inputMap, setInputMap] = useState({});

  useEffect(() => {
    props.onChangeSection(parseInt(props.sectionId));
    props.onChangeWorksheet(parseInt(props.sheetId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (input: InputFormMap) => {
    const updatedInputMap = { ...inputMap, ...input };
    props.updateWorksheetInput(props.worksheetData.id, input);
    setInputMap(updatedInputMap);
  };

  const Worksheet = worksheetsMap(+props.sectionId)?.[props.sheetId];

  return (
    <Box sx={{ display: 'flex', flex: 1, height: 'max-content', width: 'max-content' }}>
      <Worksheet.Component
        onChange={handleInputChange}
        valueMap={props.editedWorksheet.worksheetMap}
        printRef={props.printRef}
      />
    </Box>
  );
};

const mapStateToProps = state => ({
  worksheetData: state.worksheetMaker.currentWorksheetData ?? null,
  editedWorksheet: state.worksheetMaker.editedWorksheet,
  formKey: state.worksheetMaker.editedWorksheet.formKey
});

export default connect(mapStateToProps, {
  onChangeWorksheet: changeWorksheet,
  onChangeSection: changeSection,
  updateWorksheetInput
})(SheetEditor as any) as any;
